module.exports = __webpack_public_path__ + "static/media/MG.e4b4c805.jpg";